import { UpdateResolver } from '@urql/exchange-graphcache';
import {
  CreateProjectMutation,
  CreateProjectMutationVariables,
  DeleteProjectMutation,
  DeleteProjectMutationVariables,
  DuplicateProjectMutation,
  DuplicateProjectMutationVariables,
  GetProjectPageDocument,
} from '../../gql/graphql';

export const createProjectResolver: UpdateResolver = (
  result: CreateProjectMutation,
  args: CreateProjectMutationVariables,
  cache
) => {
  const newProject = result.createProject?.project;
  if (!newProject) return;
  cache
    .inspectFields('Query')
    .filter((field) => field.fieldName === 'projectsConnection')
    .forEach((field) => {
      cache.updateQuery(
        {
          query: GetProjectPageDocument,
          variables: {
            ...field.arguments,
          },
        },
        (data) => {
          if (!data?.projectsConnection) return data;
          // This assumes that we always order data in descending order
          const newNodes = [newProject, ...data.projectsConnection.nodes];
          const PAGE_SIZE =
            typeof field.arguments?.first === 'number'
              ? field.arguments.first
              : 50;
          data.projectsConnection.nodes = newNodes.slice(0, PAGE_SIZE);
          return data;
        }
      );
    });
};

export const duplicateProjectResolver: UpdateResolver = (
  result: DuplicateProjectMutation,
  args: DuplicateProjectMutationVariables,
  cache
) => {
  const newProject = result.duplicateProject?.project;
  if (!newProject) return;
  cache
    .inspectFields('Query')
    .filter((field) => field.fieldName === 'projectsConnection')
    .forEach((field) => {
      cache.updateQuery(
        {
          query: GetProjectPageDocument,
          variables: {
            ...field.arguments,
          },
        },
        (data) => {
          if (!data?.projectsConnection) return data;
          // This assumes that we always order data in descending order
          const newNodes = [newProject, ...data.projectsConnection.nodes];
          const PAGE_SIZE =
            typeof field.arguments?.first === 'number'
              ? field.arguments.first
              : 50;
          data.projectsConnection.nodes = newNodes.slice(0, PAGE_SIZE);
          return data;
        }
      );
    });
};

export const deleteProjectResolver: UpdateResolver = (
  result: DeleteProjectMutation,
  args: DeleteProjectMutationVariables,
  cache
) => {
  cache
    .inspectFields('Query')
    .filter((field) => field.fieldName === 'projectsConnection')
    .forEach((field) => {
      cache.invalidate('Query', field.fieldKey);
    });
};
